export const radii = {
  none: 0,
  xs: "4px",
  sm: "6px",
  base: "8px",
  md: "10px",
  lg: "12px",
  xl: "16px",
  surface: "18px",
  pill: "999px",
  circle: "50%",
};

export const shape = {
  borderRadius: 8,
  radii,
};
